import { ReconciliationFormValues } from 'pages/Finance/Reconciliation/utils/mapReconciliationFormToFormData';
import { useFormContext } from 'react-hook-form';
import { Box } from 'shared/mui/Box';
import { TimezoneSelectField } from 'shared/mui/Fields/TimezoneSelectField/TimezoneSelectField';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FileInput } from 'shared/react-admin/Inputs/FileInput/FileInput';

const XLSX_ACCEPT = '.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

type Props = {
  name: 'providerFile' | 'merchantFile';
  timezoneName: 'providerFileTimezone' | 'merchantFileTimezone';
  label: string;
  disabled?: boolean;
};

export const ReconciliationFileInput: React.FC<Props> = ({
  name,
  timezoneName,
  label,
  disabled,
}) => {
  const { control } = useFormContext<ReconciliationFormValues>();

  return (
    <Stack gap={2}>
      <Typography fontWeight={500} variant="subtitle1">
        {label} *
      </Typography>
      <TimezoneSelectField control={control} disabled={disabled} name={timezoneName} />
      <Box>
        <FileInput accept={XLSX_ACCEPT} disabled={disabled} name={name} />
      </Box>
    </Stack>
  );
};
